// extracted by mini-css-extract-plugin
export var backdropBlur = "_jr-0";
export var contentCard = "_jr-5";
export var frame = "_jr-2";
export var image = "_jr-4";
export var imagePane = "_jr-3";
export var modal = "_jr-1";